import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { IncludeSSRFeatureFlagsConfig } from '../../types';
var retrieveFeatureFlags = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getFeatureFlags) {
    var featureFlags;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return getFeatureFlags();
        case 3:
          featureFlags = _context.sent;
          if (!featureFlags) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return", {
            'ssr:featureFlags': featureFlags
          });
        case 6:
          _context.next = 10;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);
        case 10:
          return _context.abrupt("return", null);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 8]]);
  }));
  return function retrieveFeatureFlags(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var ssrFeatureFlags = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(config, _data, globalConfig) {
    var _globalConfig$ssr, _config$ssr, _globalConfig$ssr2, _config$ssr2;
    var includeFeatureFlags;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if ((_globalConfig$ssr = globalConfig.ssr) !== null && _globalConfig$ssr !== void 0 && _globalConfig$ssr.getFeatureFlags) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return", null);
        case 2:
          includeFeatureFlags = ((_config$ssr = config.ssr) === null || _config$ssr === void 0 ? void 0 : _config$ssr.includeFeatureFlags) || ((_globalConfig$ssr2 = globalConfig.ssr) === null || _globalConfig$ssr2 === void 0 ? void 0 : _globalConfig$ssr2.includeFeatureFlags) || IncludeSSRFeatureFlagsConfig.WHEN_FMP;
          if (!(includeFeatureFlags === IncludeSSRFeatureFlagsConfig.WHEN_AVAILABLE || (_config$ssr2 = config.ssr) !== null && _config$ssr2 !== void 0 && _config$ssr2.doneAsFmp && includeFeatureFlags === IncludeSSRFeatureFlagsConfig.WHEN_FMP)) {
            _context2.next = 7;
            break;
          }
          _context2.next = 6;
          return retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
        case 6:
          return _context2.abrupt("return", _context2.sent);
        case 7:
          return _context2.abrupt("return", null);
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function ssrFeatureFlags(_x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();